module.exports = __webpack_public_path__ + "img/project4_3.jpg.3082a293.webp";